import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of } from 'rxjs';

import { StatementResponse } from '@app/api/marketplace/models';
import { RegistrationStatementService } from '@app/api/marketplace/services';

import { StatementActions } from './statement.slice';

@Injectable({ providedIn: 'root' })
export class StatementEffects {
  loadStatement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StatementActions.loadStatement.trigger),
      exhaustMap((_action) => {
        return this.registrationStatementService
          .getProductRegistrationStatement()
          .pipe(
            map((response: StatementResponse) =>
              StatementActions.loadStatement.success(response)
            ),
            catchError(() => of(StatementActions.loadStatement.failure()))
          );
      })
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly registrationStatementService: RegistrationStatementService
  ) {}
}
